import React, { useState } from "react";
import PeriodRow from "./PeriodRow";
// import { documentservices } from "../services/documentservices";

export default function MonthlyPayrollView({ data }) {
  const info = data?.document_info;
  const periods = data?.periods || [];
  const documentId = info?.id; // ✅ source of ID

  const [expanded, setExpanded] = useState(new Set());
  const [downloading, setDownloading] = useState(false);

  const toggleAll = (open) => {
    open
      ? setExpanded(new Set(periods.map(p => p.id)))
      : setExpanded(new Set());
  };

  const toggleOne = (id) => {
    setExpanded(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  // const downloadExcel = async () => {
  //   try {
  //     if (!documentId) {
  //       console.error("Document ID missing");
  //       return;
  //     }

  //     setDownloading(true);

  //     const blob = await documentservices.downloadPayrollExcel(documentId);

  //     const url = window.URL.createObjectURL(
  //       new Blob([blob], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       })
  //     );

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = "Monthly_Payroll_Report.xlsx";

  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();

  //     window.URL.revokeObjectURL(url);
  //   } catch (err) {
  //     console.error("Excel download failed", err);
  //   } finally {
  //     setDownloading(false);
  //   }
  // };

  return (
    <>
      <br />

      {/* HEADER */}
      <div className="p-3 bg-[#5a6db3] text-white font-semibold">
        Payroll Statement Details
      </div>

      {/* INFO */}
      <div className="grid grid-cols-2 gap-6 bg-white border rounded-b-lg p-4 shadow">
        <div>
          <h4 className="font-semibold mb-2">Company Information</h4>
          <p><b>Company:</b> {info?.company_name}</p>
          <p><b>Currency:</b> {info?.currency}</p>
          <p><b>Employees:</b> {info?.total_employees}</p>
          <p><b>Frequency:</b> {info?.pay_frequency}</p>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Document Information</h4>
          <p><b>Filename:</b> {info?.filename}</p>
          <p><b>Uploaded:</b> {info?.upload_date}</p>
          <p><b>Status:</b> {info?.processing_status}</p>
          <p><b>Method:</b> {info?.extraction_method}</p>
        </div>
      </div>

      {/* PERIOD TABLE */}
      <div className="bg-white border shadow mt-6 " style={{overflow: "auto"}}>
        {/* HEADER + ACTIONS */}
        <div className="flex justify-between items-center px-4 py-3 bg-[#5a6db3] text-white">
          <span className="font-semibold">
            Period Summaries ({periods.length})
          </span>

          <div className="flex gap-2">
            {/* <button
              className="btn btn-sm btn-success"
              onClick={downloadExcel}
              disabled={downloading}
            >
              {downloading ? "⏳ Downloading..." : "⬇ Download Excel"}
            </button> */}

            <button
              className="btn btn-sm btn-light"
              onClick={() => toggleAll(true)}
            >
              ▼ Expand All
            </button>

            <button
              className="btn btn-sm btn-light"
              onClick={() => toggleAll(false)}
            >
              ▶   All
            </button>
          </div>
        </div>

        <div className="scroll-container" >
      <div className="scroll-content table-wrapper">
        <table className="align-items-center table-flush sticky-table" responsive>
          <thead className="thead-light thead-fixed sticky">
              <tr>
                <Th w={140}>Period</Th>
                <Th w={120}>End Date</Th>
                <Th w={90}>Emp</Th>
                <Th w={140} align="right">Gross</Th>
                <Th w={140} align="right">Taxable</Th>
                <Th w={140} align="right">NIC-able</Th>
                <Th w={120} align="right">Tax</Th>
                <Th w={140} align="right">Emp NICs</Th>
                <Th w={180} align="right">Loans</Th>
                <Th w={140} align="right">Net</Th>
                <Th w={160} align="right">Take-home</Th>
                <Th w={140} align="right">Er NICs</Th>
                <Th w={160} align="right">Er Pension</Th>
                <Th w={160} align="right">Total Cost</Th>
                <Th w={90} align="center">View</Th>
              </tr>
            </thead>

            <tbody className="divide-y">
              {periods.map(p => (
                <PeriodRow
                  key={p.id}
                  period={p}
                  isOpen={expanded.has(p.id)}
                  onToggle={() => toggleOne(p.id)}
                />
              ))}
            </tbody>
          </table>
        </div> </div>
      </div>
    </>
  );
}

/* =================== TABLE HEADER =================== */

const Th = ({ children, w, align = "left" }) => (
  <th
    style={{ minWidth: w }}
    className={`px-3 py-2 border text-${align} whitespace-nowrap`}
  >
    {children}
  </th>
);
